import React, { useEffect, useRef, useState } from 'react';
import { useHistory, NavLink } from 'react-router-dom';

import Background from '../assets/img/home_bg.png';
import KPMG from '../assets/img/partners/KPMG.png';
import Reply from '../assets/img/partners/Reply.png';
import Educom from '../assets/img/partners/Educom.png';
import Telespazio from '../assets/img/partners/Telespazio.png';
import { FeaturesCard } from '../components/cards';
import { FlatButton, OutlinedButton, PrimaryButton, SecondaryButtonWhite } from '../components/buttons';
import { Helmet } from 'react-helmet';
import { useTimer } from '../commons/hooks';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useTranslation } from 'react-i18next';

import ReactPixel from 'react-facebook-pixel';

const words: string[] = [
  'analytics',
  'cache',
  'Real-time BI',
  'IoT',
  'Real-time AI'
];

enum AnimationState {
  WRITING_NEW_WORD,
  DELETING_WORD,
  DELAYING_DELETE,
}

const LandingPage: React.FC<{}> = (props) => {

  const { t, i18n } = useTranslation();

  const fbpAdvancedMatching = undefined //{ em: 'some@email.com' }
  const fbpOptions = {
    autoConfig: true,
    debug: false,
  }

  const features = [{
    title: t("landing.features_performance"),
    description: t("landing.features_performance_des"),
    icon: <div className="relative h-8 w-8"><svg className="w-8 absolute top-0.5" fill="#FFFFFF" height="26" viewBox="0 0 488.6 488.6" ><path d="M188.5,270.3c-24.4,28.1-23.2,71.7,2.6,98.6c14.4,15.1,33.7,22.6,52.9,22.6c18.8,0,37.5-7.2,51.8-21.5	c6.5-6.5,11.6-14,15.1-21.9l0,0l94.5-183.2c2.5-5.2-2.9-10.6-8.1-8.1l-183.2,94.5l0,0C204.6,255.5,195.9,261.9,188.5,270.3zM221.9,296.1c6.1-6.1,14.1-9.2,22.1-9.2s16,3.1,22.2,9.2c12.2,12.2,12.2,32.1,0,44.3c-6.1,6.1-14.1,9.2-22.2,9.2c-8,0-16-3.1-22.1-9.2C209.6,328.1,209.6,308.3,221.9,296.1z M440.2,341.4c0-34.6-9.1-68.6-26.4-98.3c-6.7-11.6-2.8-26.4,8.8-33.1c11.6-6.7,26.4-2.8,33.1,8.8c21.5,37.1,32.9,79.5,32.9,122.6c0,13.4-10.8,24.2-24.2,24.2C451.1,365.6,440.2,354.8,440.2,341.4zM0,341.4C0,206.7,109.6,97.1,244.3,97.1c31.3,0,61.8,5.8,90.6,17.4c12.4,5,18.4,19,13.5,31.4c-5,12.4-19,18.4-31.4,13.5c-23.1-9.2-47.6-13.9-72.7-13.9c-108,0-195.9,87.9-195.9,195.9c0,13.4-10.8,24.2-24.2,24.2C10.8,365.6,0,354.8,0,341.4z" /></svg></div>
  }, {
    title: t("landing.features_peer_to_peer"),
    description: t("landing.features_peer_to_peer_des"),
    icon: <i className="fas fa-network-wired text-white text-lg"></i>
  }, {
    title: t("landing.features_cloud_native"),
    description: t("landing.features_cloud_native_des"),
    icon: <svg className="h-7 w-7" fill="#FFFFFF" id="Cloud_native" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="Cloud"><g><path d="m421 406h-330c-24.05 0-46.794-9.327-64.042-26.264-17.384-17.069-26.958-39.705-26.958-63.736s9.574-46.667 26.958-63.736c13.614-13.368 30.652-21.995 49.054-25.038-.008-.406-.012-.815-.012-1.226 0-66.168 53.832-120 120-120 24.538 0 48.119 7.387 68.194 21.363 14.132 9.838 25.865 22.443 34.587 37.043 14.079-8.733 30.318-13.406 47.219-13.406 44.886 0 82.202 33.026 88.921 76.056 18.811 2.88 36.244 11.581 50.122 25.208 17.383 17.069 26.957 39.704 26.957 63.736s-9.574 46.667-26.957 63.736c-17.249 16.937-39.993 26.264-64.043 26.264zm-330-150c-33.636 0-61 26.916-61 60s27.364 60 61 60h330c33.636 0 61-26.916 61-60s-27.364-60-61-60h-15v-15c0-33.084-26.916-60-60-60-15.766 0-30.68 6.12-41.995 17.233l-16.146 15.858-8.315-21.049c-13.689-34.651-46.482-57.042-83.544-57.042-49.626 0-90 40.374-90 90 0 3.544.556 7.349 1.144 11.378l2.687 18.622z" /></g></g></svg>
  }, {
    title: t("landing.features_scalability"),
    description: t("landing.features_scalability_des"),
    icon: <i className="fas fa-chart-line text-white text-lg"></i>
  }, {
    title: t("landing.features_replication"),
    description: t("landing.features_replication_des"),
    icon: <i className="far fa-clone text-white text-lg"></i>
  }, {
    title: t("landing.features_sql"),
    description: t("landing.features_sql_des"),
    icon: <i className="fas fa-search text-white text-lg"></i>
  }];

  const isUserAuthenticated = useSelector((state: RootState) => state.user?.logged)
  const [animationState, setAnimationState] = useState<AnimationState>(AnimationState.DELETING_WORD);
  const [index, setIndex] = useState(0);
  const [usedWord, setUsedWord] = useState(words[0]);
  const history = useHistory();
  const featureRef = useRef<HTMLElement>(undefined!)
  const timer = useTimer();

  //Function triggered when the explore button is clicked
  function handleExploreClick() {
    if (featureRef && featureRef.current) {
      window.scrollTo({
        top: featureRef.current.offsetTop,
        behavior: 'smooth'
      })
    }
  }

  //Function triggered when the contact us button is clicked
  function handleContactUsClick() {
    history.push('/contacts');
  }


  //Hook automating the typewriting behaviour of page title
  useEffect(() => {
    const typeWrite = () => {
      if (animationState === AnimationState.WRITING_NEW_WORD) {
        if (usedWord.length < words[index].length) {
          let additionalChars: number;
          //Blank spaces makes the animation weird. This for cycle is to avoid that this animation
          //uses a cycle to add only a whitespace. In this way one char is always added
          for (additionalChars = 0; words[index].charAt(usedWord.length) === ' ' && (usedWord.length + additionalChars) < words[index].length; additionalChars++);
          setUsedWord(words[index].substr(0, usedWord.length + additionalChars + 1));
        } else {
          setAnimationState(AnimationState.DELAYING_DELETE)
        }
      } else if (animationState === AnimationState.DELAYING_DELETE) {
        setAnimationState(AnimationState.DELETING_WORD)
      } else {
        if (usedWord.length > 0) {
          setUsedWord(usedWord.substr(0, usedWord.length - 1))
        } else {
          setAnimationState(AnimationState.WRITING_NEW_WORD)
          setIndex((index + 1) % words.length) //Cycle over the words continuously
        }
      }
    }

    const cursorAnimation: boolean = (
      animationState === AnimationState.DELAYING_DELETE
    )

    timer.setTimer(() => typeWrite(), (cursorAnimation) ? 1200 : 70);
  }, [usedWord, index, animationState, timer])

  //ReactPixel.init('1859871174464801', fbpAdvancedMatching, fbpOptions)
  //if (hasMarketingPreference) {
  //console.log("I've just viewed the page!")
  //ReactPixel.pageView()
  //} else {
  //ReactPixel.revokeConsent()
  //}

  useEffect(() => {
    ReactPixel.init('1859871174464801', fbpAdvancedMatching, fbpOptions)
    console.log("I've just viewed the page!")
    ReactPixel.pageView()
 }, []);

  return (
    <>
      <Helmet>
        <title>AyraDB - Home</title>
        <meta
          name="description"
          content="AyraDB provides sub-millisecond latency on disk, with no data caching in memory. AyraDB enables big data applications at scale, with reliable performance, predictable hardware requirements, and 20 times lower hardware costs."
        />
        <link
          rel="canonical"
          href="ayradb.com"
        />
      </Helmet>
      <div className="pt-12 w-screen overflow-hidden">
        <section className="relative py-12 landscape:h-screen flex flex-row items-center justify-between space-x-8">
          <div className="flex flex-col min-h-100 sm:min-h-0 justify-center items-center sm:items-start px-10 md:pl-20 md:pr-0">
            <h1 className="font-semibold text-4xl xl:text-5xl text-gunmetal font-intro tracking-tighter sm:whitespace-nowrap text-center sm:text-left">
              AyraDB - {t("landing.title_word_a")} <br className="" />{t("landing.title_word_powerful")} <br className="hidden sm:block md:hidden" /> {t("landing.title_word_database")} <br className="" /> {t("landing.title_word_for")} <span className="text-cherry-red-400">{usedWord}</span> <span className={`text-cherry-red-400 ${animationState === AnimationState.DELAYING_DELETE ? 'animate-blink' : ''}`}>|</span>
            </h1>
            <p className="mt-4 text-sm xl:text-base leading-relaxed text-gunmetal-300 text-center sm:text-left">
              {t("landing.des")}
            </p>
            <div className="mt-8 lg:mt-16 w-40 2xs:w-80 xs:w-92 flex flex-col 2xs:flex-row space-y-4 2xs:space-y-0 2xs:space-x-4 justify-center items-center">
              {
                isUserAuthenticated
                  ? <PrimaryButton className="w-full flex-1 py-2 md:py-3" onClick={() => history.push("/console")} >{t("landing.open_console")}</PrimaryButton>
                  : <PrimaryButton className="w-full flex-1 py-2 md:py-3" onClick={() => history.push({pathname: '/contacts', search: '?autofill=try'})} >{t("landing.try_free")}</PrimaryButton>
              }
              <OutlinedButton
                onClick={() => handleExploreClick()}
                className={`w-full flex-1 py-2 md:py-3`}
              >
                {t("landing.explore")}
              </OutlinedButton>
            </div>
          </div>
          <img className="hidden bg-fixed sm:block xs:max-w-xs sm:max-w-sm lg:max-w-half max-h-screen-five-sixths pr-10 md:pr-20" src={Background} alt="Background"></img>
        </section>
        <section ref={featureRef} className="relative bg-gradient-to-br from-cherry-red-900 via-cherry-red-400 to-cherry-red-250">
          <svg className="absolute" width="100%" height="100%" viewBox="0 0 1440 451"><g transform="translate(-30, 0)" id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group-9" opacity="0.3"><g style={{ transform: "translate(0px, -15.1801px)" }}><g id="r-1" style={{ transform: "translateX(19.0397px)" }}><rect id="Rectangle-6" fill="#FFFFFF" transform="translate(41.000000, 169.000000) rotate(-27.000000) translate(-41.000000, -169.000000) " x="11" y="139" width="60" height="60" rx="2"></rect></g></g><g style={{ transform: "translate(0px, -13.9245px)" }}><g id="p-1" style={{ transform: "translateX(-19.0397px)" }}><polygon id="Polygon" stroke="#FFFFFF" strokeWidth="2" transform="translate(139.000000, 17.500000) rotate(45.000000) translate(-139.000000, -17.500000) " points="139 77 152 100 126 100"></polygon></g></g><g style={{ transform: "translate(0px, 1.25717px)" }}><g id="p-2" style={{ transform: "translateX(28.5595px)" }}><polygon id="Polygon" stroke="#FFFFFF" transform="translate(180.000000, 446.000000) rotate(-67.000000) translate(-180.000000, -446.000000) " points="180 439 188 453 172 453"></polygon></g></g><g style={{ transform: "translate(0px, -8.45332px)" }}><g id="c-1" style={{ transform: "translateX(-28.5595px)" }}><circle id="Oval" stroke="#FFFFFF" strokeWidth="3" fill="#FFFFFF" cx="256" cy="357" r="10"></circle></g></g></g><g id="Group-8" transform="translate(1219.000000, 69.000000)" stroke="#FFFFFF"><g style={{ transform: "translate(0px, -10.0686px)" }}><g id="r-2" style={{ transform: "translateX(-9.51983px)" }}><rect id="Rectangle-6" strokeWidth="2" opacity="0.3" transform="translate(47.000000, 343.000000) rotate(-45.000000) translate(-47.000000, -343.000000) " x="15" y="311" width="64" height="64" rx="2"></rect></g></g><g style={{ transform: "translate(0px, -22.2799px)" }}><g id="c-2" style={{ transform: "translateX(38.0793px)" }}><circle id="Oval" strokeWidth="3" fill="#FFFFFF" opacity="0.4" cx="155" cy="13" r="13"></circle></g></g><g style={{ transform: "translate(0px, 11.5963px)" }}><g id="c-3" style={{ transform: "translateX(-28.5595px)" }}><circle id="Oval" strokeWidth="2" opacity="0.4" cx="211" cy="225" r="8"></circle></g></g></g></g></svg>
          <div className="relative -top-1">
            <svg width="100%" viewBox="0 -2 1920 157" version="1.1">
              <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Artboard" fill="#f6f7fb" fillRule="nonzero">
                  <g id="wave-down">
                    <path d="M0,60.8320331 C299.333333,115.127115 618.333333,111.165365 959,47.8320321 C1299.66667,-15.5013009 1620.66667,-15.2062179 1930,47.8320331 L1930,156.389409 L-10,156.389409 L-10,60.8320331 Z" id="Path-Copy-2" transform="translate(960.000000, 78.416017) rotate(180.000000) translate(-960.000000, -78.416017) "></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div className="relative px-10 md:px-20 pb-28 sm:pb-24 pt-24 flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-16 z-10 justify-between">
            <div className="w-full pb-8 lg:w-1/3">
              <h1 className="tracking-tighter text-5xl 2xl:text-6xl font-intro text-white">{t("landing.main_features")}</h1>
              <h2 className="text-gray-100 w-10/12 sm:w-2/3 md:w-1/2 lg:w-full pt-3 font-docs-element text-sm 2xs:text-base xl:text-lg">{t("landing.main_features_des_prefix")} <NavLink to="/learn/features" className=" text-white hover:text-gunmetal-500 underline">{t("landing.main_features_des_documentation")}</NavLink> {t("landing.main_features_des_suffix")}</h2>
            </div>
            <div className="w-full lg:w-2/3 lg:px-2 max-w-3xl">
              <FeaturesCard
                features={features}
              />
            </div>
          </div>
          <div className="relative -bottom-0.5">
            <svg width="100%" viewBox="0 -1 1920 166" version="1.1">
              <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Artboard-2" transform="translate(0.000000, 5.000000)" fill="#f6f7fb" fillRule="nonzero">
                  <g id="wave-up">
                    <path d="M0,70 C298.666667,105.333333 618.666667,95 960,39 C1301.33333,-17 1621.33333,-11.3333333 1920,56 L1920,165 L0,165 L0,70 Z" id="Path"></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </section>
        <section className="flex flex-col lg:flex-row items-center lg:space-x-10 px-10 xl:px-20 pb-12 xs:pb-16">
          <div className="relative w-full sm:w-10/12 md:w-8/12 lg:w-6/12 xl:w-4/12 mr-auto ml-auto -top-20 sm:-top-28 max-w-md">
            <div className="relative flex flex-col min-w-0 break-word w-full mb-6 shadow-lg rounded-lg bg-cherry-red-400">
              <img
                alt="..."
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
                className="w-full align-middle rounded-t-lg"
              />
              <blockquote className="relative px-8 pt-8 pb-4 text-sm sm:text-base">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  className="absolute left-0 w-full block h-95px -top-94px"
                >
                  <polygon
                    points="-30,95 583,95 583,65"
                    className="text-cherry-red-400 fill-current"
                  ></polygon>
                </svg>
                <h4 className="text-xl font-bold text-white">
                {t("landing.benefits")}
                </h4>
                <ul className="list-outside list-disc text-md font-light mt-2 ml-4 text-white space-y-2">
                  <li>{t("landing.benefits_use")}</li>
                  <li>{t("landing.benefits_reduce")}</li>
                  <li>{t("landing.benefits_improve")}</li>
                  <li>{t("landing.benefits_store")}</li>
                  <li>{t("landing.benefits_leverage")}</li>
                </ul>
              </blockquote>
              <div className="flex justify-end p-2">
                <FlatButton
                  onClick={() => history.push('/learn/features')}
                  className="hover:bg-white hover:bg-opacity-30 px-4 py-1.5 text-white text-sm font-bold rounded"
                >
                  {t("landing.benefits_see_features")}
                </FlatButton>
              </div>
            </div>
          </div>
          <div className="w-full md:w-10/12 lg:w-6/12">
            <div className="grid grid-cols-2 gap-8 pb-16 pt-8 sm:pt-16">
              <div className="col-span-1 relative flex flex-col">
                <div className="flex-auto">
                  <div className="text-cherry-red-400 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                    <i className="fas fa-coins"></i>
                  </div>
                  <h6 className="text-xl mb-1 font-semibold">
                  {t("landing.benefits_save")}
                  </h6>
                  <p className="mb-4 text-cherry-red-400">
                  {t("landing.benefits_save_des")}
                  </p>
                </div>
              </div>
              <div className="col-span-1 relative flex flex-col min-w-0">
                <div className="flex-auto">
                  <div className="text-cherry-red-400 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <h6 className="text-xl mb-1 font-semibold">
                  {t("landing.benefits_enable")}
                  </h6>
                  <p className="mb-4 text-cherry-red-400">
                  {t("landing.benefits_enable_des")}
                  </p>
                </div>
              </div>
              <div className="col-span-1 relative flex flex-col min-w-0">
                <div className="flex-auto">
                  <div className="text-cherry-red-400 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                    <i className="fas fa-unlock"></i>
                  </div>
                  <h6 className="text-xl mb-1 font-semibold">{t("landing.benefits_unlock")}</h6>
                  <p className="mb-4 text-cherry-red-400">
                  {t("landing.benefits_unlock_des")}
                  </p>
                </div>
              </div>
              <div className="col-span-1 relative flex flex-col min-w-0">
                <div className="flex-auto">
                  <div className="text-cherry-red-400 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                    <i className="fas fa-leaf"></i>
                  </div>
                  <h6 className="text-xl mb-1 font-semibold">
                  {t("landing.benefits_green")}
                  </h6>
                  <p className="mb-4 text-cherry-red-400">
                  {t("landing.benefits_green_des")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="flex flex-col items-center pb-8">
          {/* FIXME: TITOLO DA USARE QUANDO AVREMO USE CASE VALIDI */}
          {/* <h2 className="text-sm xs:text-4xl text-center font-semibold text-gunmetal-400">Find out how companies are innovating with AyraDB</h2> */}
          <h2 className="text-2xl xs:text-3xl text-center font-semibold text-gunmetal-400">{t("landing.partners")}</h2>
          <div className="flex flex-col xl:flex-row space-y-8 xl:space-y-0 xl:space-x-12 py-12 px-10 xl:px-20">
            <div className="flex-1 block xs:flex xs:flex-row space-y-8 xs:space-y-0 xs:space-x-12">
              <img className="flex-1 h-18 xs:h-16 mx-auto xs:mx-0" src={KPMG} alt="KPMG"></img>
              <img className="flex-1 h-18 xs:h-16 mx-auto xs:mx-0" src={Reply} alt="Reply"></img>
            </div>
            <div className="flex-1 block xs:flex xs:flex-row space-y-8 xs:space-y-0 xs:space-x-12">
              <img className="flex-1 h-18 xs:h-16 mx-auto xs:mx-0 bg-gunmetal-450 p-1" src={Educom} alt="Educom"></img>
              <img className="flex-1 h-18 xs:h-16 mx-auto xs:mx-0" src={Telespazio} alt="Telespazio"></img>
            </div>
          </div>
        </section>
        <div className="relative -bottom-0.5">
          <svg width="100%" viewBox="0 -1 1920 166" version="1.1">
            <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Artboard-2" transform="translate(0.000000, 5.000000)" fill="#2A343C" fillRule="nonzero">
                <g id="wave-up">
                  <path d="M0,70 C298.666667,105.333333 618.666667,95 960,39 C1301.33333,-17 1621.33333,-11.3333333 1920,56 L1920,165 L0,165 L0,70 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <section className="bg-gunmetal-500 px-10 lg:px-20 pt-10 pb-18 flex flex-col items-center">
          <h1 className="text-3xl xs:text-4xl text-center font-semibold text-white">{t("landing.manage_big_data")}</h1>
          <h2 className="text-base xs:text-lg text-center text-white mt-4">{t("landing.manage_big_data_des")}</h2>
          <div className="mt-8 lg:mt-12 w-40 2xs:w-80 xs:w-96 flex flex-col 2xs:flex-row space-y-4 2xs:space-y-0 2xs:space-x-4 justify-center items-center">
            {
              isUserAuthenticated
                ? <PrimaryButton className="py-2 md:py-3 w-full 2xs:flex-1" onClick={() => history.push("/console")}>{t("landing.open_console")}</PrimaryButton>
                : <PrimaryButton className="py-2 md:py-3 w-full 2xs:flex-1" onClick={() => history.push({pathname: '/contacts', search: '?autofill=try'})}>{t("landing.try_free")}</PrimaryButton>
            }
            <SecondaryButtonWhite
              onClick={() => handleContactUsClick()}
              className={`py-2 md:py-3 w-full flex-1`}
            >
              {t("landing.contact_us")}
            </SecondaryButtonWhite>
          </div>
        </section>
      </div>
    </>
  );
}

export default LandingPage;